import axios from 'axios';
import { zendoStorage } from '../../hybrid/wrappers';
import { getCurrencies, getDisplaySettings, getIsSponsor, getLangs, getMenu, getSettings } from '../utils/memo';
import { API_SERVER_URL } from '../utils/utils';
import { getData } from '../utils/router';
import moment from 'moment';

export function getDomenData(href) {
    try {
        if (!href) return false;
        const url = new URL(href);
        const searchParams = new URLSearchParams(url.search);
        return {
            ref: searchParams.get('ref'),
            id: searchParams.get('id'),
            hash: searchParams.get('hash')
        };
    } catch (e) {
        return false;
    }
}

export const getTokenByIdAndHash = async (id, hash) => {
    const data = await axios({
        method: 'POST',
        url: `${API_SERVER_URL}/api/v1/shopify/login`,
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json;charset=UTF-8'
        },
        data: JSON.stringify({
            id,
            hash
        })
    });

    return data?.data?.data?.token || false;
};
export const processUrlParams = async (self, userToken, referFromURL) => {
    const params = getDomenData(window?.location?.href);
    const refer = referFromURL || params?.ref;
    if (refer) {
        try {
            const dataValidReferalReq = await getIsSponsor(userToken, refer);

            if (!dataValidReferalReq || dataValidReferalReq?.errors) {
                self.setState({ refer: false });
                zendoStorage.remove('refer');
                if (params?.ref) {
                    return self.props.router.push('/error/refer');
                }
            } else {
                self.setState({ refer });
                zendoStorage.set('refer', refer);
                // if (params?.ref) {
                //     const domain = SITE_URL.replace('http://', '').replace('https://', '');
                //     const redirectUrl = removeURLParameter(
                //         window.location.href.replace('http://', '').replace('https://', '').replace(domain, ''),
                //         'ref'
                //     );

                //     return document.location.assign(`${SITE_URL}${redirectUrl}`);
                // }
            }
        } catch {
            self.setState({ refer: false });
            zendoStorage.remove('refer');
            if (params?.ref) {
                return self.props.router.push('/error/refer');
            }
        }
    } else if (params?.id && params?.hash) {
        try {
            const dataValidHash = await getTokenByIdAndHash(params?.id, params?.hash);
            if (!dataValidHash) {
                return self.props.router.push('/error/403');
            } else {
                await self.newToken(dataValidHash);
                if (params?.id && params?.hash) {
                    return self.props.router.push('/office');
                }
            }
        } catch {
            return self.props.router.push('/error/403');
        }
    }
};

export const getAltPageProps = async (self, userToken) => {
    let { activeLangs, currencies, settings, seo, offset, lang, menu, marketingCurrency } = { ...self.state };
    const localization = zendoStorage.get('localization') ? JSON.parse(zendoStorage.get('localization')) : {};

    if (!activeLangs) {
        activeLangs = await getLangs();
        self.setState({ activeLangs });
    }

    if (!currencies || userToken) {
        currencies = await getCurrencies(lang, userToken);
        self.setState({ currencies });
    }
    if (!localization.country?.id) {
        let localizationData = (await getData('/api/v1/geonames/country-by-ip', userToken, lang)) || {};
        localization.country = {
            id: localizationData?.data?.geoname_id,
            code: localizationData?.data?.country
        };
        const localCurrency = currencies?.data?.find((el) => el.code === localizationData?.data?.currency);
        const localLang = activeLangs?.find((el) => el.alias === localizationData?.data?.language);

        if (localCurrency && !localization.currency) {
            localization.currency = localCurrency.code;
        } else if (localization.currency) {
            const isActiveCurrency = currencies?.data?.find((el) => el.code === localization.currency);
            if (!isActiveCurrency) {
                if (localCurrency) {
                    localization.currency = localCurrency.code;
                } else {
                    localization.currency = false;
                }
            }
        }
        if (localLang && !localization.country?.language) {
            localization.country.language = localLang.alias;
        }
    }

    if (!localization.currency) {
        localization.currency = currencies?.data?.find((el) => el.main === true)?.code || 'USD';
    } else {
        const isActiveCurrency = currencies?.data?.find((el) => el.code === localization.currency);
        if (!isActiveCurrency) {
            localization.currency = currencies?.data?.find((el) => el.main === true)?.code || 'USD';
        }
    }

    localization.language = lang;

    self.setState({ localization });

    if (!settings) {
        settings = await getDisplaySettings(lang);
        self.setState({ settings });
    }

    if (!self.state.seo) {
        seo = await getSettings('seo');
        self.setState({ seo });
    }
    if (!offset) {
        const timeRes = await getData('/api/v1/settings/date', false, lang);
        const time = moment(timeRes?.data?.date, 'YYYY-MM-DD HH:mm:ss');
        const newOffset = time.diff(moment(new Date()));
        self.setState({ offset: newOffset });
    }
    if (!marketingCurrency) {
        const dataCurrencyMark = await getData('/api/v1/user/finance/marketing-currency', userToken, lang);

        self.setState({ marketingCurrency: dataCurrencyMark?.data || {} });
    }

    const promisesAliases = self.props.pageProps?.protect
        ? ['office', 'admin', 'site', 'footer']
        : ['site', 'footer', 'office', 'admin'];
    let newMenu = { ...(menu || {}) };
    for (let index = 0; index < promisesAliases.length; index++) {
        const alias = promisesAliases[index];
        new Promise((resolve) => {
            if (newMenu[alias]) {
                resolve();
            } else {
                getMenu(alias).then((data) => {
                    newMenu = { ...newMenu, ...data };
                    self.setState({ menu: newMenu });
                    resolve();
                });
            }
        });
    }
};
